import { loadImages } from "../utils/importImages";

const outdoorImages = loadImages(
  require.context("./Images", false, /Out\d+\.webp$/)
);

function Outdoor() {
  return (
    <div id="scroll-container" className="scroll-container">
      <h2>Outdoors</h2>
      {outdoorImages.map((src, index) => (
        <img
          key={index}
          src={src}
          alt={`Outdoor ${index + 1}`}
          loading="lazy"
        />
      ))}
    </div>
  );
}

export default Outdoor;
